import { Temporal } from "temporal-polyfill";

// The server resets the window at midnight on the first in the business
// unit's timezone. Every supported unit timezone is at or west of New York,
// so formatting the instant in New York still shows the reset's calendar date.
const ALLOWANCE_DISPLAY_TIMEZONE = "America/New_York";

function formatResetDate(resetsAt: string): string {
  return Temporal.Instant.from(resetsAt)
    .toZonedDateTimeISO(ALLOWANCE_DISPLAY_TIMEZONE)
    .toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
}

export function describeRunAllowanceLimit({
  monthlyFreeLimit,
  resetsAt,
}: {
  monthlyFreeLimit: number | null;
  resetsAt: string | null;
}): string {
  if (!monthlyFreeLimit) {
    return "This business unit needs a billing plan to run verifications. Contact Saile to set up billing.";
  }
  const noun = monthlyFreeLimit === 1 ? "verification" : "verifications";
  const used = `This business unit has used its ${monthlyFreeLimit} free ${noun} for this month. Contact Saile to set up billing to run more verifications.`;
  if (!resetsAt) {
    return used;
  }
  return `${used} Free verifications reset on ${formatResetDate(resetsAt)}.`;
}
